import { render, staticRenderFns } from "./standard-report-form.vue?vue&type=template&id=331aaf3e&"
import script from "./standard-report-form.vue?vue&type=script&lang=js&"
export * from "./standard-report-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports